// Mirror of backend ROLES (src/backend/src/api/middleware/authorize.js).
// Lower value = more privileges. Root ('0') is stored as a string, so compare with Number().
export const ROLES = { ROOT: 0, ADMIN: 1, MANAGER: 2, USER: 3 }

// True when the user's role is `role` or more privileged.
export const hasRole = (permissions, role) => Number(permissions) <= role
